import { RtTrip } from '@bds/reference-models';

export class CLMSelectDialogModel {
    title?: string;
    actionText: string;
    dismissiveText = 'Cancel';
    trip: RtTrip;
}
